// extracted by mini-css-extract-plugin
export default {"container":"JobsHead_container__6EkWQ","title":"JobsHead_title__x-7pP","paragraph":"JobsHead_paragraph__-mjge"};